import { mergeMap } from "rxjs/operators";
import { Action } from "@ngrx/store";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
    PROFILE_ACCEPT_DATA_PROCESS_SUCESS,
    PROFILE_DATA_OF_CURRENT_RECEIVED_SUCCESSFUL,
    ProfileAcceptDataProcessAction,
    ProfileAcceptDataProcessSuccessAction,
    ProfileDataReceivedSuccessfulAction,
} from "../../profile/store/profile.action";
import {
    APPOINTMENT_OVERVIEW_MULTIUSER_UPCOMING,
    DASHBOARD_ROUTE,
    WAITINGROOM_MULTIUSER_ROUTE,
} from "../../../routes";
import { Profile, ProfileType } from "../../profile/store/profile.entity";
import {
    PreInitCompletedAction,
    PreInitDataProcessTermAcceptedAction,
} from "./pre-init.action";
import { Observable, of } from "rxjs";
import { RouterHelperService } from "../../utils/router-helper/router-helper.service";
import { RestrictedFeatureRouteMap } from "../../../entities/institution/institution.model";

@Injectable()
export class PreInitEffects {
    constructor(
        private actions$: Actions,
        private routerHelper: RouterHelperService,
        private router: Router,
    ) {}

    // PRE_INIT_START_CHECK: At the moment is not needed to listen on

    checkForDataProcessTerm$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(PROFILE_DATA_OF_CURRENT_RECEIVED_SUCCESSFUL),
            mergeMap((action: ProfileDataReceivedSuccessfulAction) => {
                if (
                    action.payload.type === ProfileType.PATIENT &&
                    action.payload.dataProcessTerm === false
                ) {
                    return of(
                        new ProfileAcceptDataProcessAction(action.payload),
                    );
                } else {
                    this.navigateOnLogin(action);
                    return of(new PreInitCompletedAction());
                }
            }),
        ),
    );

    markDataProcessTermAccepted$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(PROFILE_ACCEPT_DATA_PROCESS_SUCESS),
            mergeMap((action: ProfileAcceptDataProcessSuccessAction) => {
                this.navigateToRoute(action.payload, {
                    skipIfOnLegalPage: true,
                });

                const actions: Action[] = [
                    new PreInitDataProcessTermAcceptedAction(),
                    new PreInitCompletedAction(),
                ];

                return actions;
            }),
        ),
    );

    private navigateOnLogin(action: ProfileDataReceivedSuccessfulAction): void {
        this.navigateToRoute(action.payload, { skipIfOnLegalPage: true });
    }

    private navigateToRoute(
        profile: Profile,
        options?: { skipIfOnLegalPage?: boolean },
    ): void {
        if (
            options?.skipIfOnLegalPage &&
            this.routerHelper.isLegalDocumentUrl(this.router.url)
        ) {
            return;
        }
        const institutionRoutes =
            RestrictedFeatureRouteMap[profile.institution];
        if (
            institutionRoutes &&
            !institutionRoutes.hasOwnProperty(DASHBOARD_ROUTE)
        ) {
            profile.type === ProfileType.PATIENT
                ? this.routerHelper.navigate([WAITINGROOM_MULTIUSER_ROUTE])
                : this.routerHelper.navigate([
                      APPOINTMENT_OVERVIEW_MULTIUSER_UPCOMING,
                  ]);
        } else {
            this.routerHelper.navigate([DASHBOARD_ROUTE]);
        }
    }
}
